var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "chart-title" }, [
        _vm._v("The Wildlife Trusts' MPA Recovery Check overview statistics."),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "mpa-condition-count" } }),
      _vm._v(" "),
      _c("p", { staticStyle: { "font-size": "80%" } }, [
        _vm._v(
          "Notes: hover the bars to show how many sites contributed to these percentages. Additional information on how the condition has been assessed can be found in the information section. The number of MPAs may not be a whole number due to some MPAs being split between different countries."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }